import React from "react";
import "./imagePolygon.css";

const ImagePolygonItem = ({ index, src, clipPath, style }) => {
  return (
    <div className="image-item" data-index={index + 1}>
      <div
        className="image-box"
        style={{
          backgroundImage: `url(${src})`,
          clipPath: clipPath,
          WebkitClipPath: clipPath,
          ...style,
        }}
      />
    </div>
  );
};

export default ImagePolygonItem;
